var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 512 512"
      }
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M262.12,378a15,15,0,0,1-7.33-1.91A230.8,230.8,0,0,1,136.68,174.88q0-2.5.06-5c.8-37.5,14.81-69.11,40.52-91.4C199.91,58.82,230.05,48,262.12,48S324.32,58.82,347,78.47c25.71,22.29,39.72,53.9,40.52,91.4h0q.06,2.5.06,5A230.8,230.8,0,0,1,269.44,376.09,15,15,0,0,1,262.12,378Zm0-300c-24.85,0-48,8.21-65.21,23.13-19.13,16.59-29.57,40.58-30.18,69.38,0,1.45,0,2.91,0,4.37a200.76,200.76,0,0,0,95.44,170.73,200.75,200.75,0,0,0,95.43-170.73c0-1.46,0-2.92-.05-4.37h0c-.61-28.8-11.05-52.79-30.18-69.38C310.12,86.21,287,78,262.12,78Z"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M262.43,247.4a72.13,72.13,0,1,1,72.13-72.13A72.21,72.21,0,0,1,262.43,247.4Zm0-114.25a42.13,42.13,0,1,0,42.13,42.12A42.17,42.17,0,0,0,262.43,133.15Z"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M262.12,450c-40.47,0-78.75-8.06-107.79-22.69C122,411,104.23,388.19,104.23,363c0-33.41,31.25-62.26,83.6-77.16A15,15,0,0,1,196,314.7c-37.55,10.69-61.81,29.65-61.81,48.3,0,27,52.52,57,127.89,57S390,390,390,363c0-18.65-24.26-37.61-61.81-48.3a15,15,0,0,1,8.21-28.86C388.75,300.74,420,329.59,420,363c0,25.19-17.79,48-50.1,64.31C340.86,441.94,302.58,450,262.12,450Z",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": "10",
            "stroke-width": "20"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }